export default __webpack_public_path__ + "static/media/smartstudio-footer-logo.59fae951.svg";